export default __webpack_public_path__ + "static/media/blog.ae1a00bc.PNG";